import { render, staticRenderFns } from "./editChecklists.vue?vue&type=template&id=36accc25&scoped=true&"
import script from "./editChecklists.vue?vue&type=script&lang=js&"
export * from "./editChecklists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36accc25",
  null
  
)

export default component.exports